export default __webpack_public_path__ + "static/media/Foto12.2defcb09.png";